import { LoginType, LoginResponse } from "./auth.types";
import { APIService } from "../../services/api-service";

export const login = (request?: LoginType) => {
  const url = `api/v1/login`;
  return APIService.post<LoginType, LoginResponse>(url, request);
};
